<div class="main">
    <router-outlet></router-outlet>
</div>